<div (click)="routingService.open('/main/animal-ping-schedule')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    <div class=" d-flex justify-content-between">
        <div class=" fs-main fw-bold mb-3">Animal ping schedule</div>
        <div class=" mt-auto mb-auto">
            <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
        </div>
    </div>
        <div>
            <img src="icons/stopwatch-twenty.svg" class="icon"/>
        </div>
</div>
